// extracted by mini-css-extract-plugin
export default {"value":"CapacityResults_value__claE8","wrapper":"CapacityResults_wrapper__BCv+Z"};